import React from 'react';
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined} from 'Skelet/src/modules/fetch.action.js'
import {openModal, closeModal} from 'Skelet/src/modules/functions.js'
import {time_ago_human} from 'Skelet/src/modules/time_ago.js'
// import refresh_icon from './28406.svg';


class Bounties extends React.Component {

  constructor(props) {
    super(props);
    this.state = {page:0, modal_open:false, modal_content:{}, modal_create_open:false};
  }

  componentWillMount() {
    if(this.props.session_token) {
      //this.props.fetchDataIfReady(config.api_token, "bounty-index", "GET", config.api_url+"/bounty-index?t="+this.props.session_token, undefined, {"PM-List-Page":this.state.page});
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      //this.props.fetchDataIfUndefined(config.api_token, "bounty-index", "GET", config.api_url+"/bounty-index?t="+nextProps.session_token);
    }
  }

  render() {
    const {account_plan} = this.props;
    let cards = "", end_of_list_text = "", page_bounties = this.props.apiData["bounty-index"];
      page_bounties = {data:[
          {id:122,
          created_at:"2024-04-02T15:20:00Z",
          name_masked:"a PC Game",
          type:"twitch_stream",
          payout:"xxx,xx",
          duration:"1 hour",
          available_until:"31-09-2024",
          complete_by:"31-10-2024"},
          {id:123,
          created_at:"2024-02-02T16:20:00Z",
          name_masked:"a PC Game",
          type:"twitch_stream",
          payout:"99,99",
          duration:"1 hour",
          available_until:"31-07-2024",
          complete_by:"31-08-2024"},
          {id:456,
          created_at:"2024-02-01T16:20:00Z",
          name_masked:"a Banner Ad",
          type:"youtube_banner",
          payout:"100,00",
          duration:"1 video",
          available_until:"18-05-2024",
          complete_by:"11-06-2024"},
          {id:789,
          created_at:"2024-01-25T16:20:00Z",
          name_masked:"a PC Game",
          type:"twitch_stream",
          payout:"0,55 per viewer per hour",
          duration:"1 hour",
          available_until:"31-07-2024",
          complete_by:"31-08-2024"}
      ]};
      let page_bounties_unlocked = {data:[
          {id:122,
          name:"Example Game",
          company:"Example Company",
          contact_email:"contact@company.eu"
          },
          {id:123,
          name:"Call of Duty WWII [PC]",
          company:"Activision Blizzard",
          contact_email:"contact@company.eu"
          },
          {id:456,
          name:"a McDonald's Banner Ad",
          company:"McDonald's",
          contact_email:"contact@company.eu"
          }
      ]};
    if(page_bounties !== undefined) {
      cards = page_bounties.data.map(function(item, i) {
        let created_at = new Date(item.created_at);
        let timestamp = created_at.toLocaleString();
        item.timestamp = timestamp;
        let today = new Date();
        let now = new Date();
        today.setHours(0,0,0,0);
        if(today.getTime() < created_at.getTime()) { // if created_at is today, display only the time
          timestamp = created_at.toLocaleTimeString();
        }

        let time_ago = (now.getTime() - created_at.getTime()) / 1000 / 60; // minutes
        let time_ago_txt = time_ago_human(time_ago);
        item.time_ago_txt = time_ago_txt;

        let bounty_title_prefix = "";
        let bounty_title_affix = "";
        let bounty_title_name = item.name_masked;
        if(item.type === "twitch_stream") {
          bounty_title_prefix = "Stream";
          bounty_title_affix = "for "+item.duration;
        } else if(item.type === "youtube_banner") {
          bounty_title_prefix = "Place";
          bounty_title_affix = "on "+item.duration;
        }

        let bounty_unlocked = false;
        let bounty_unlock_info = {};
          // todo: check if any bounties are unlocked for first view
        cards = page_bounties_unlocked.data.map(function(unlock_item, i) {
            //console.log(unlock_item);
          if(unlock_item.id === item.id) {
            bounty_unlocked = true;
            bounty_title_name = unlock_item.name;
            bounty_unlock_info = unlock_item;
          }
        });

        return <div key={i}>
          <small style={{marginTop:"2em", marginBottom:"10px", opacity:".5", display:"block", fontSize:"75%", textAlign:"right"}}>created {item.time_ago_txt}</small>
          <div className="card polls" style={(bounty_unlocked) ? {borderLeft:"3px solid #7729c6"} : null}>
            <div className="card-layout">
              <div className="card-layout-div85">{bounty_title_prefix} <b>{bounty_title_name}</b> {bounty_title_affix}<br/>Available until {item.available_until}</div>
              <div className="card-layout-div15" style={{textAlign:"right"}}>&euro; {item.payout}</div>
            </div>
            <div>
              {/*<p style={{marginBottom:"0"}}>{bounty_title_prefix} <b>{bounty_title_name}</b> {bounty_title_affix}</p>
              <small>{item.type}</small>*/}
              <ul style={{marginTop:"2em"}}>
                <li>Don&apos;t bad-mouth the brand.</li>
                <li>Put <b>#Sponsored or #Ad</b> in your stream title.</li>
                <li>Turn on the &quot;Store Past Broadcasts&quot; option in your Channel Settings.</li>
                <li>Complete the bounty by <b>{item.complete_by}</b>.</li>
              </ul>
            </div>
            <div className="card-layout">
              <div className="card-layout-div75"><h3 style={{margin:"3em 0"}}>Payout: &euro; {item.payout}</h3></div>
              <div className="card-layout-div25" style={{textAlign:"right"}}>{!bounty_unlocked && <Link to="/" className="btn" onClick={(e) => openModal(this, e, item)}>Take Bounty</Link>}</div>
            </div>
            {!bounty_unlocked && <div style={{textAlign:"right"}}><small>By clicking &quot;Take Bounty&quot; you let the Company know you are interested in this Bounty.</small></div>}
            {/* maybe add: "Your registered email address is available to the Company to contact you." */}
            {bounty_unlocked && <div style={{textAlign:"right"}}>{bounty_unlock_info.company}<br/>{bounty_unlock_info.contact_email}</div>}
          </div>
        </div>;
      }.bind(this));
    }

    if(page_bounties === undefined || page_bounties.isFetching) {
      end_of_list_text = "Loading..";
    } else if((page_bounties !== undefined && !page_bounties.isFetching && page_bounties.limitReached)) {
      if(page_bounties.data[0] !== undefined) {
        end_of_list_text = "End of results."; // End of results.
      } else {
        end_of_list_text = "No results."; // No results.
      }
    }

    return (
      <div className="container content">
        <div className="card-layout">
          <div className="card-layout-div50"><strong>Bounties (Example)</strong></div>
          <div className="card-layout-div50 index-actions">
            {(false) && <button className="btn" style={{borderColor:"#222"}} onClick={() => openModal(this, null, null, "modal_create_open")}>create bounty</button>}
          </div>
        </div>
        {cards}
        <div className="end_of_list_text">{end_of_list_text}</div>
{/*<ModalPoll shouldShow={this.state.modal_open} close={() => closeModal(this)} content={this.state.modal_content} account_plan={account_plan} />
        <ModalCreatePoll shouldShow={this.state.modal_create_open} close={() => closeModal(this, "modal_create_open")} />*/}
      </div>
    );
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Bounties)



// WEBPACK FOOTER //
// ./src/containers/Bounties.js